import { defineStore } from 'pinia'
import { ModuleType } from '~/types/menu'
import { useAuthStore } from './auth'
import { useSystemStore } from './system'

export const useRouterStore = defineStore('router', {
  state: () => ({
    moduleId: null as ModuleType | null,
    apiUrl: null as string | null
  }),

  getters: {
    // apiUrl: (state): string => state.client ? `https://lumen.clinux.com.br/chamados/cgi-bin/dwserver.cgi/se1/dotListaCgi?id=${state.client}` : '',
    homeUrl: (state): string => {
      const auth = useAuthStore()
      const user: any = auth.user
      if (state.moduleId === ModuleType.CLINUX)
        return user?.idmedico ? '/laudo/gestao' : '/'
      if (state.moduleId === ModuleType.PORTAL)
        return '/paciente'
      if (state.moduleId === ModuleType.RESULTADO)
        return '/paciente'
      if (state.moduleId === ModuleType.DOCTOR)
        return '/solicitante'
      if (state.moduleId === ModuleType.OTRS)
        return '/otrs'
      if (state.moduleId === ModuleType.QUESTIONARIO)
        return '/paciente/questionario'
      return '/'
    }
  },

  persist: {
    storage: typeof window !== 'undefined' ? localStorage : undefined
  },

  actions: {
    async loadClient(): Promise<boolean> {
      const router = useRoute()

      // Aliases: nomes alternativos mapeados para o module real
      const systemAliases: Record<string, ModuleType> = {
        synapse: ModuleType.CLINUX
      }
      const systemParam = router.params.system as string
      const resolvedSystem = systemAliases[systemParam] ?? systemParam

      if (!Object.values(ModuleType).includes(resolvedSystem as any))
        return useMessage().showError(`ID not found: ${systemParam}`)
      this.moduleId = resolvedSystem as ModuleType
      // router.query pode estar vazio em SPA antes da hidratação; usa URLSearchParams como fallback
      const clientFromQuery = router.query.client || new URLSearchParams(window.location.search).get('client')
      if (!clientFromQuery) {
        this.apiUrl = `${window.location.origin}/api`
        // this.apiUrl = 'http://localhost:8082'
      } else {
        const url = `https://lumen.clinux.com.br/chamados/cgi-bin/dwserver.cgi/se1/dotListaCgi?id=${clientFromQuery}`
        const data = await useHttpApi(url)
        this.apiUrl = data?.[0]?.ds_portal_url ?? null
        if (!this.apiUrl)
          return useMessage().showError(`Client ID not found: ${clientFromQuery}`)
        useSystemStore().icon = null
      }
      return true
    }
  }
})
